const steps = [
  {
    icon: (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    iconBg: "bg-teal-100",
    iconColor: "text-teal-600",
    number: "1",
    title: "Plan your itinerary",
    description: "Share your preferences and let our advanced AI generate a completely personalized, day-by-day itinerary tailored just for you.",
  },
  {
    icon: (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
    iconBg: "bg-orange-100",
    iconColor: "text-orange-600",
    number: "2",
    title: "Collaborate and modify",
    description: "Invite friends or family to your trip board. Modify activities, vote on choices, and refine the plan together in real-time.",
  },
  {
    icon: (
      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    ),
    iconBg: "bg-teal-100",
    iconColor: "text-teal-600",
    number: "3",
    title: "Get deals & book",
    description: "Metasearch results for all your travels, in one place. Compare options and seamlessly book your entire trip at the best prices.",
  },
];

export default function JourneySection() {
  return (
    <section id="how-it-works" className="bg-gray-100 pt-10 md:pt-56 lg:pt-64 pb-10 sm:pb-14 md:pb-16 lg:pb-20 px-4 sm:px-6 lg:px-8 border-t border-gray-200 md:border-t-0">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 sm:mb-10 md:mb-14">
          <p className="text-teal-600 text-[10px] sm:text-xs font-semibold tracking-wider uppercase mb-2 sm:mb-3">
            Simple & Efficient
          </p>
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-2 sm:mb-3 md:mb-4">
            Craft Your Ideal Journey
          </h2>
          <p className="text-gray-600 text-xs sm:text-sm md:text-base max-w-xl md:max-w-2xl mx-auto leading-relaxed">
            Planning a trip shouldn't be stressful. Follow these three simple steps to unlock your perfect adventure with Romaya AI.
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-8 lg:top-10 left-[20%] right-[20%]">
            <div className="border-t-2 border-dashed border-gray-300"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 md:gap-6 lg:gap-12">
            {steps.map((step, index) => (
              <div key={index} className="relative text-center">
                <div className="relative inline-flex mb-3 sm:mb-4 md:mb-6">
                  <div className={`w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 ${step.iconBg} ${step.iconColor} rounded-xl sm:rounded-2xl flex items-center justify-center shadow-sm`}>
                    {step.icon}
                  </div>
                </div>

                <h3 className="text-sm sm:text-base lg:text-lg font-bold text-gray-900 mb-2 sm:mb-3">
                  {step.number}. {step.title}
                </h3>

                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed max-w-[280px] sm:max-w-xs mx-auto">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
